import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { VoterImportProgressEvent } from '@signalvote/shared';

interface ImportProgressState {
  /** Current import progress from SSE stream */
  progress: VoterImportProgressEvent | null;
  /** Increment to force SSE reconnect (e.g., after starting a new import) */
  sseGeneration: number;
  /** Whether the user dismissed a terminal state */
  dismissed: boolean;
  /** Whether the active job is a re-geocode (vs a normal import) */
  isRegeocode: boolean;

  setProgress: (progress: VoterImportProgressEvent | null) => void;
  bumpSse: () => void;
  /** Bump SSE and mark the job as a re-geocode */
  startRegeocode: () => void;
  dismiss: () => void;
}

export const useImportProgressStore = create<ImportProgressState>()(
  devtools(
    (set) => ({
      progress: null,
      sseGeneration: 0,
      dismissed: false,
      isRegeocode: false,

      setProgress: (progress) =>
        set({ progress, dismissed: false }, false, 'setProgress'),

      bumpSse: () =>
        set(
          (s) => ({ sseGeneration: s.sseGeneration + 1, dismissed: false, isRegeocode: false }),
          false,
          'bumpSse'
        ),

      startRegeocode: () =>
        set(
          (s) => ({ sseGeneration: s.sseGeneration + 1, dismissed: false, isRegeocode: true }),
          false,
          'startRegeocode'
        ),

      dismiss: () => set({ dismissed: true, progress: null, isRegeocode: false }, false, 'dismiss'),
    }),
    { name: 'import-progress-store' }
  )
);
